import { useEffect, useRef } from 'react';

import { trackSpotlightSearch } from '@/lib/mixpanel/mixpanel';

interface UseSpotlightSearchTrackingParams {
  isFetching: boolean;
  page: number;
  resultsCount: number | null;
  searchValue: string;
  userId: number | null;
}

export const useSpotlightSearchTracking = ({
  isFetching,
  page,
  resultsCount,
  searchValue,
  userId,
}: UseSpotlightSearchTrackingParams): void => {
  const lastTrackedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const trimmedSearch = searchValue.trim();

    if (trimmedSearch.length === 0) {
      lastTrackedKeyRef.current = null;
      return;
    }

    if (userId === null || isFetching || resultsCount === null) {
      return;
    }

    const trackingKey = `${trimmedSearch}|${page}|${resultsCount}`;
    if (lastTrackedKeyRef.current === trackingKey) {
      return;
    }

    lastTrackedKeyRef.current = trackingKey;
    trackSpotlightSearch({
      is_pagination: page > 1,
      results_count: resultsCount,
      search_query: trimmedSearch,
      user_id: userId,
    });
  }, [isFetching, page, resultsCount, searchValue, userId]);
};
